/* eslint-disable no-debugger */
import { call, put, takeEvery } from "redux-saga/effects";
import { ERROR_MESSAGE, APP_CODE } from "common/constants";
import fetchApi from "utils/fetchApi";
import { AuthorizationActionTypes } from "./types";
import {
  fetchUserInfo,
  fetchCommonMap,
  fetchLogout,
  fetchAppList,
  fetchMenuList,
  fetchAppSave,
  fetchUserPermission,
  fetchConfigAppList,
  fetchGetProjectSetting,
} from "./actions";

/**
 * 执行获取用户信息
 *
 */
function* handleFetchUserInfo() {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(fetchApi, "get", "home-server/auth/userAndCompany");

    // 请求结果调度
    if (res.result === 0 && res.data) {
      // 获取配置
      // yield put(fetchGetProjectSetting.request());

      yield put(fetchUserInfo.success(res.data.extra));

      // 获取当前用户应用列表
      yield put(fetchAppList.request());

      // 获取配用应用列表
      yield put(fetchConfigAppList.request());

      // 获取当前用户权限列表
      yield put(fetchUserPermission.request());

      // 获取数据字典
      yield put(fetchCommonMap.request());
    } else {
      yield put(fetchUserInfo.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchUserInfo.failure(msg));
  }
}

/**
 * 执行获取应用列表
 *
 */
function* handleFetchAppList() {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(fetchApi, "get", "permissionServer/user/app/list");

    // 请求结果调度
    if (res.result === 0 && res.data) {
      // const filterApps = res.data.records.filter((record: any) => record.appName.toLowerCase().indexOf("smarthr") === -1);
      const filterApps = (res.data.records || []).filter(
        (record: any) =>
          ["smarthr", "驻场通"].indexOf(record.appName.toLowerCase()) === -1
      );
      // yield put(fetchAppList.success(res.data.records));
      yield put(fetchAppList.success(filterApps));
    } else {
      yield put(fetchAppList.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchAppList.failure(msg));
  }
}

/**
 * 获取应用列表
 *
 */
function* handleFetchConfigAppList() {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(fetchApi, "get", "home-server/user/app/list");

    // 请求结果调度
    if (res.result === 0 && res.data) {
      yield put(fetchConfigAppList.success(res.data.records));
    } else {
      yield put(fetchConfigAppList.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchConfigAppList.failure(msg));
  }
}

/**
 * 执行获取应用权限列表
 *
 */
function* handleFetchUserPermission() {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(
      fetchApi,
      "get",
      `permissionServer/user/function/list/${APP_CODE}`
    );

    // 请求结果调度
    if (res.result === 0 && res.data) {
      yield put(fetchUserPermission.success(res.data.records));
    } else {
      yield put(fetchUserPermission.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchUserPermission.failure(msg));
  }
}

/**
 * 保存常用应用列表
 *
 */
function* handleFetchAppSave(action: ReturnType<typeof fetchAppSave.request>) {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(
      fetchApi,
      "post",
      "permissionServer/user/app/frequently/list",
      action.payload
    );

    // 请求结果调度
    if (res.result === 0) {
      yield put(fetchAppSave.success());
      yield put(fetchAppList.request());
    } else {
      yield put(fetchAppSave.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchAppSave.failure(msg));
  }
}

/**
 * 执行获取应用列表
 *
 */
function* handleFetchMenuList(
  action: ReturnType<typeof fetchMenuList.request>
) {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(
      fetchApi,
      "get",
      `permissionServer/user/leftnavgation/${action.payload.appId}`
    );

    // 请求结果调度
    if (res.result === 0 && res.data) {
      yield put(fetchMenuList.success(res.data.records));
      // yield put(fetchMenuList.success([{
      //   id: "1",
      //   groupName: "",
      //   groupIconName: "",
      //   /**
      //    * 功能名称
      //    */
      //   functionName: "个人用户",
      //   /**
      //    * 功能编码
      //    */
      //   functionCode: "1",
      //   /**
      //    * 功能图标
      //    */
      //   iconName: "ms-user-info",
      //   /**
      //    * 访问地址
      //    */
      //   visitURL: "/personal",
      // }, {
      //   id: "2",
      //   groupName: "",
      //   groupIconName: "",
      //   /**
      //    * 功能名称
      //    */
      //   functionName: "企业用户",
      //   /**
      //    * 功能编码
      //    */
      //   functionCode: "2",
      //   /**
      //    * 功能图标
      //    */
      //   iconName: "ms-user-info",
      //   /**
      //    * 访问地址
      //    */
      //   visitURL: "/enterprise",
      // }]));
    } else {
      yield put(fetchMenuList.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchMenuList.failure(msg));
  }
}

/**
 * 获取数据字典
 *
 */
function* handleFetchCommonMap() {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(fetchApi, "get", "permissionServer/meta/all");

    // 请求结果调度
    if (res.result === 0 && res.data) {
      yield put(fetchCommonMap.success(res.data.extra));
    } else {
      yield put(fetchCommonMap.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchCommonMap.failure(msg));
  }
}

/**
 * 执行登出操作
 *
 */
function* handleFetchLogout() {
  try {
    // 调用异步函数，向后台发送请求
    const res = yield call(fetchApi, "get", "home-server/auth/logout");

    // 请求结果调度
    if (res.result === 0) {
      yield put(fetchLogout.success(res.data));
    } else {
      yield put(fetchLogout.failure(res.detail));
    }
  } catch (err) {
    const msg = err instanceof Error ? err.stack! : ERROR_MESSAGE;
    yield put(fetchLogout.failure(msg));
  }
}

function* handleFetchQueryTenantFontPageStyleByDomain(
  action: ReturnType<typeof fetchGetProjectSetting.request>
) {
  try {
    const res = yield call(
      fetchApi,
      "post",
      "api/platform-manager/api/manager/font-page-meta-info/queryTenantFontPageStyleByDomain",
      action.payload
    );

    if (res) {
      if (
        res.result === 0 &&
        Object.keys(res.data).length &&
        res.data.formatTemplateJson
      ) {
        yield put(
          fetchGetProjectSetting.success(
            JSON.parse(res.data.formatTemplateJson)
          )
        );
      } else {
        yield put(fetchGetProjectSetting.failure(res.detail));
      }
    }
  } catch (err) {
    // message.error(err instanceof Error ? err.stack! : ERROR_MESSAGE);
  }
}

// 监控，根据指定action类型，调用saga方法
function* authorizationSaga() {
  yield takeEvery(
    AuthorizationActionTypes.FETCH_USER_INFO,
    handleFetchUserInfo
  );
  yield takeEvery(AuthorizationActionTypes.FETCH_APP_LIST, handleFetchAppList);
  yield takeEvery(
    AuthorizationActionTypes.FETCH_CONFIG_APP_LIST,
    handleFetchConfigAppList
  );
  yield takeEvery(
    AuthorizationActionTypes.FETCH_USER_PERMISSION,
    handleFetchUserPermission
  );
  yield takeEvery(AuthorizationActionTypes.FETCH_APP_SAVE, handleFetchAppSave);
  yield takeEvery(
    AuthorizationActionTypes.FETCH_MENU_LIST,
    handleFetchMenuList
  );
  yield takeEvery(
    AuthorizationActionTypes.FETCH_COMMON_MAP,
    handleFetchCommonMap
  );
  yield takeEvery(AuthorizationActionTypes.FETCH_LOGOUT, handleFetchLogout);
  yield takeEvery(
    AuthorizationActionTypes.FETCH_GET_PROJECT_SETTING,
    handleFetchQueryTenantFontPageStyleByDomain
  );
}
export default authorizationSaga;
